import Zone from "./Zone";
import './Map.css';

function Map(props) {
    return (
        <div className="map-wrapper">
          <div className="helper">
            {document.documentElement.lang === "de"
              ? (
                <>
                  Klicken Sie auf eine Zone<br/>um die Preise zu sehen
                </>
              )
              : (
                <>
                  Cliquer sur une zone<br/>pour voir les prix
                </>
              )
            }
          </div>
          <img
            src="/fileadmin/user_upload/public/plan_general_des_zones_2025.png"
            width="4134" height="5514"/>
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px"
               y="0px"
               viewBox="0 0 892.9 1190.6">
                {
                    Object.entries(props.zones).map(([zoneId, zone]) => {
                        return <Zone key={zoneId} zoneId={zoneId} zone={zone}></Zone>
                    })
                }
            </svg>
        </div>
    )
}

export default Map;
